import { render, staticRenderFns } from "./Opz2KpiSettingsRequestModal.vue?vue&type=template&id=46f2b1cc&scoped=true"
import script from "./Opz2KpiSettingsRequestModal.vue?vue&type=script&lang=ts"
export * from "./Opz2KpiSettingsRequestModal.vue?vue&type=script&lang=ts"
import style0 from "./Opz2KpiSettingsRequestModal.vue?vue&type=style&index=0&id=46f2b1cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f2b1cc",
  null
  
)

export default component.exports